import React from "react";
import Modal from "../Modal";

export default function TeamDeleteModal({
  isOpen,
  onClose,
  teamName,
  confirmInput,
  setConfirmInput,
  onDelete
}) {
  return (
    isOpen && (
      <Modal isOpen={isOpen} onClose={onClose}>
        <div className="text-center">
          <h2 className="text-lg font-semibold mb-4 text-red-600 dark:text-red-400">Delete Team</h2>
          <p className="mb-2 text-sm text-gray-600 dark:text-gray-300">
            This action cannot be undone. To confirm, please type <span className="font-semibold text-red-700 dark:text-red-400">{teamName}</span> below.
          </p>
          <input
            type="text"
            className="w-full px-3 py-2 mb-4 rounded border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-gray-100"
            placeholder="Enter team name to confirm"
            value={confirmInput}
            onChange={e => setConfirmInput(e.target.value)}
            autoFocus
          />
          <div className="flex justify-center gap-4 mb-6">
            <button
              className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 transition"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 rounded bg-gradient-to-r from-red-500 to-red-700 text-white hover:from-red-600 hover:to-red-900 transition font-semibold disabled:opacity-60 disabled:cursor-not-allowed"
              disabled={confirmInput !== teamName}
              onClick={onDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>
    )
  );
}
